// ============================================
// Path: /frontend/src/api/users.api.js
// Purpose: Users API endpoints
// ============================================

import apiClient from './client.js';

export const usersAPI = {
  // Get featured dealers (public)
  getFeaturedDealers: async () => {
    console.log('[usersAPI] Fetching featured dealers (public)');
    try {
      const response = await apiClient.get('/users/featured');
      console.log('[usersAPI] Fetched', response.data.users?.length || 0, 'dealers');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching featured dealers:', error);
      throw error;
    }
  },

  // Get all dealers (public)
  getAllDealers: async () => {
    console.log('[usersAPI] Fetching all dealers (public)');
    try {
      const response = await apiClient.get('/users/dealers');
      console.log('[usersAPI] Fetched', response.data.users?.length || 0, 'dealers');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching all dealers:', error);
      throw error;
    }
  },

  // Get featured agents (public)
  getFeaturedAgents: async () => {
    console.log('[usersAPI] Fetching featured agents (public)');
    try {
      const response = await apiClient.get('/users/featured-agents');
      console.log('[usersAPI] Fetched', response.data.users?.length || 0, 'agents');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching featured agents:', error);
      throw error;
    }
  },

  // Get all agents (public)
  getAllAgents: async () => {
    console.log('[usersAPI] Fetching all agents (public)');
    try {
      const response = await apiClient.get('/users/agents');
      console.log('[usersAPI] Fetched', response.data.users?.length || 0, 'agents');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching all agents:', error);
      throw error;
    }
  },

// Get all users (admin only)
  getAllUsers: async (params = {}) => {
    console.log('[usersAPI] Fetching all users (admin) with params:', params);
    try {
      const response = await apiClient.get('/users', { params });
      console.log('[usersAPI] Fetched', response.data.users?.length || 0, 'users');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching users:', error);
      throw error;
    }
  },
  
  // Get pending approvals (admin only) - NEW
  getPendingApprovals: async () => {
    console.log('[usersAPI] Fetching pending approvals (admin)');
    try {
      const response = await apiClient.get('/users/pending-approvals');
      console.log('[usersAPI] Fetched', response.data.users?.length || 0, 'pending users');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching pending approvals:', error);
      throw error;
    }
  },

  // Approve user (admin only) - NEW
  approveUser: async (id) => {
    console.log('[usersAPI] Approving user:', id);
    try {
      const response = await apiClient.patch(`/users/${id}/approve`);
      console.log('[usersAPI] User approved successfully');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error approving user:', error);
      throw error;
    }
  },

  // Update account status (admin only) - NEW
  updateAccountStatus: async (id, status) => {
    console.log('[usersAPI] Updating account status:', id, 'to', status);
    try {
      const response = await apiClient.patch(`/users/${id}/status`, { status });
      console.log('[usersAPI] Account status updated successfully');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error updating account status:', error);
      throw error;
    }
  },

  // Reject user (admin only) - NEW
  rejectUser: async (id, reason) => {
    console.log('[usersAPI] Rejecting user:', id, 'Reason:', reason);
    try {
      const response = await apiClient.patch(`/users/${id}/reject`, { reason });
      console.log('[usersAPI] User rejected successfully');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error rejecting user:', error);
      throw error;
    }
  },

  // Get user by ID
  getUser: async (id) => {
    console.log('[usersAPI] Fetching user:', id);
    try {
      const response = await apiClient.get(`/users/${id}`);
      console.log('[usersAPI] User fetched:', response.data.user?.email);
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error fetching user:', error);
      throw error;
    }
  },

  // Update user
  updateUser: async (id, userData) => {
    console.log('[usersAPI] Updating user:', id, userData);
    try {
      const response = await apiClient.patch(`/users/${id}`, userData);
      console.log('[usersAPI] User updated successfully');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error updating user:', error);
      throw error;
    }
  },

  // Update user role (admin only)
  updateUserRole: async (id, role) => {
    console.log('[usersAPI] Updating user role:', id, 'to', role);
    try {
      const response = await apiClient.patch(`/users/${id}/role`, { role });
      console.log('[usersAPI] User role updated successfully');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error updating user role:', error);
      throw error;
    }
  },

  // Delete user (admin only)
  deleteUser: async (id) => {
    console.log('[usersAPI] Deleting user:', id);
    try {
      const response = await apiClient.delete(`/users/${id}`);
      console.log('[usersAPI] User deleted successfully');
      return response.data;
    } catch (error) {
      console.error('[usersAPI] Error deleting user:', error);
      throw error;
    }
  },
};